<template>
  <b-navbar
    class="menu-view"
    role="menubar"
    :aria-label="$t('menu.aria-nav-bar')"
  >
    <template #start>
      <b-navbar-item
        tag="router-link"
        :to="{ path: '/applications' }"
      >
        <img
          class="logo_OA"
          src="@/assets/Logos_OA.svg"
          alt="The Open ADOM Logo"
        >
      </b-navbar-item>
      <b-navbar-item
        v-if="pathname === '/applications' && ownApplicationsNumber !== 0"
        tag="router-link"
        :to="{ path: '/applications' }"
        :aria-label="$t('menu.applications')"
        @click="$emit('update-applications-list', 'ownApplications')"
      >
        <b-icon icon="city" />
        <span>
          <p :aria-label="$t('titles.applications-page')">{{ $t("titles.applications-page") }}</p>
        </span>
      </b-navbar-item>
      <b-navbar-item
        v-if="pathname === '/applications' && otherApplicationsNumber !== 0"
        tag="router-link"
        :to="{ path: '/applications' }"
        :aria-label="$t('menu.applications')"
        @click="$emit('update-applications-list', 'otherApplications')"
      >
        <b-icon icon="hotel" />
        <span>
          <p :aria-label="$t('titles.applications-page-other')">{{ $t("titles.applications-page-other") }}</p>
        </span>
      </b-navbar-item>
      <b-navbar-item
        v-if="application"
        tag="router-link"
        :to="{ path: '/applications/' + application.name }"
        :aria-label="application.localName"
      >
        <b-icon icon="home" />
        <span>
          <p>{{ application.localName }}</p>
        </span>
      </b-navbar-item>
    </template>

    <template #end>
      <b-navbar-item tag="div">
        <b-field>
          <b-select
            v-model="chosenLocale"
            :placeholder="$t('menu.language')"
            icon="globe"
            rounded
            @update:model-value="setUserPrefLocale"
          >
            <option
              :value="locales.FRENCH"
              :aria-label="$t('menu.french')"
            >
              {{ $t("menu.french") }}
            </option>
            <option
              :value="locales.ENGLISH"
              :aria-label="$t('menu.english')"
            >
              {{ $t("menu.english") }}
            </option>
          </b-select>
        </b-field>
      </b-navbar-item>

      <b-navbar-item
        v-if="currentUser.openAdomAdmin"
        tag="div"
      >
        <b-field>
          <b-button
            tabindex="0"
            :aria-label="$t('menu.authorizations')"
            icon-left="building-shield"
            @click="showApplicationRightManagement()"
            @keyup.enter="showApplicationRightManagement()"
          />
        </b-field>
      </b-navbar-item>

      <b-navbar-item tag="div">
        <b-field>
          <b-button
            tabindex="0"
            :aria-label="$t('titles.profile')"
            icon-left="user-astronaut"
            @click="editUser()"
            @keyup.enter="editUser()"
          />
        </b-field>
      </b-navbar-item>

      <b-navbar-item
        tag="div"
        class="logout"
      >
        <b-field>
          <b-button
            tabindex="0"
            aria-label="logout"
            icon-left="sign-out-alt"
            @click="logout()"
            @keyup.enter="logout()"
          />
        </b-field>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script lang="ts">
import services from "@/composable/services";
import { chosenLocale, locales, setUserPrefLocale } from "@/composable/locales/locales";
import { onMounted, PropType } from "vue";
import { useRouter } from "vue-router";
import useObject from "@/composable/components/object";
import { BButton, BField, BIcon, BNavbar, BNavbarItem, BSelect } from "buefy";
import "@/style/views/MenuView.scss";
import { LocalApplicationResult } from "@/types/front/LocalApplicationResult";
import { LoginAdminResult } from "@/types/generated/UsedGeneratedTypes";

export default {
  name: "MenuView",
  components: { BButton, BSelect, BField, BIcon, BNavbarItem, BNavbar },
  props: {
    application: {
      type: Object as PropType<LocalApplicationResult>,
      default: null,
    },
    listApplications: {
      type: String,
      default: "",
    },
    otherApplicationsNumber: {
      type: Number,
      default: 0,
    },
    ownApplicationsNumber: {
      type: Number,
      default: 0,
    },
  },
  emits: ["update-applications-list"],
  setup(props) {
    const router = useRouter();
    const pathname = window.location.pathname;
    const { reactiveObject: currentUser, doChangeObject: changeCurrentUser } = useObject({} as LoginAdminResult);

    onMounted(async () => {
      chosenLocale.value = services.userPreferencesService.getUserPrefLocale();
      changeCurrentUser(Object.assign(currentUser, services.loginService.getAuthenticatedUser()));
    });

    function logout() {
      if (props.application && props.application.name) {
        services.loginService.logout(props.application.name);
      }
      else {
        services.loginService.logout();
      }
    }
    function editUser() {
      let userLoginOrId = currentUser.login;
      router.push(`/users/${userLoginOrId}`);
    }
    function showApplicationRightManagement() {
      router.push("/authorizationsManagementForApplicationCreator");
    }
    return {
      // from composable/locales/locales.ts
      locales,
      chosenLocale,
      setUserPrefLocale,
      currentUser,
      logout,
      editUser,
      showApplicationRightManagement,
      pathname,
    };
  },
};
</script>
